<template>
  <div>
    <el-divider />
    <h3>Medical Condition</h3>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="">
        <el-input-title required>Do you have any medical conditions?</el-input-title>
        <el-form-item prop="meta.medical.hasMedical">
          <el-select class="mt-05 w-100" v-model="value.meta.medical.hasMedical" placeholder="Select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="">
        <el-input-title required>Please specify</el-input-title>
        <el-form-item prop="meta.medical.notes">
          <el-input
            class="mt-05"
            v-model="value.meta.medical.notes"
            placeholder=""
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-divider />
    <h3>Additional Details</h3>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="">
        <el-input-title>School</el-input-title>
        <el-form-item prop="meta.school">
          <el-input
            class="mt-05"
            v-model="value.meta.school"
            placeholder=""
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="">
        <el-input-title required>I do NOT consent to photography</el-input-title>
        <el-form-item prop="meta.photographyOptOut">
          <el-select class="mt-05 w-100" v-model="value.meta.photographyOptOut" placeholder="Select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="">
        <el-input-title required>Are you a Usyd Staff Member?</el-input-title>
        <el-form-item prop="meta.isStaff">
          <el-select class="mt-05 w-100" v-model="value.meta.isStaff" placeholder="Select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="">
        <el-input-title required>Are you a USyd Student?</el-input-title>
        <el-form-item prop="meta.isStudent">
          <el-select class="mt-05 w-100" v-model="value.meta.isStudent" placeholder="Select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="">
        <el-input-title required>How did you find out about us?</el-input-title>
        <el-form-item prop="meta.findAboutUs">
          <el-select class="mt-05 w-100" v-model="value.meta.findAboutUs" clearable placeholder="Select">
            <el-option
              v-for="item in findAboutUsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>

export default {
  name: 'unisydExtra',
  props: ['value'],
  data() {
    return {
      options: [
        {
          value: true,
          label: 'Yes'
        },
        {
          value: false,
          label: 'No'
        },
      ],
      findAboutUsOptions: [
        { value: 'Brochure', label: 'Brochure' },
        { value: 'Club Sport', label: 'Club Sport' },
        { value: 'Facilities/Signage', label: 'Facilities/Signage' },
        { value: 'Google/Website', label: 'Google/Website' },
        { value: 'Newspaper', label: 'Newspaper' },
        { value: 'Previous Attendee', label: 'Previous Attendee' },
        { value: 'Radio', label: 'Radio' },
        { value: 'ROAR Magazine', label: 'ROAR Magazine' },
        { value: 'School', label: 'School' },
        { value: 'School Fete/Community Festival', label: 'School Fete/Community Festival' },
        { value: 'Shopping Centre', label: 'Shopping Centre' },
        { value: 'Social Media', label: 'Social Media' },
        { value: 'Sydney Uni Sport Newsletter', label: 'Sydney Uni Sport Newsletter' },
        { value: 'Word of Mouth', label: 'Word of Mouth' },
        { value: 'Others', label: 'Others' },
      ]
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
